import script from "./prestation.vue?vue&type=script&lang=ts&setup=true"
export * from "./prestation.vue?vue&type=script&lang=ts&setup=true"

import "./prestation.vue?vue&type=style&index=0&id=f573bca6&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f573bca6"]])

export default __exports__